import memberHandlers from './member';
import documentHandlers from './documents';
import operatorTaskHandlers from './operatorTasks';
import bankDataHandlers from './bankData';
import quilttHandlers from './quiltt';
import bookkeepingHandlers from './bookkeeping';
import hintStatusHandlers from './hintStatus';
import hurdlrHandlers from './hurdlr';
import payrollHandlers from './payroll';
import hubPayrollHandlers from './hubPayroll';
import sscFunnelHandlers from './sscFunnel';
import oauthHandlers from './oauth';
import gustoHandlers from './gusto';
import legalConsentsHandlers from './legalConsents';
import qteHandlers from './qte';

const handlerGroups = [
    memberHandlers,
    documentHandlers,
    operatorTaskHandlers,
    bankDataHandlers,
    quilttHandlers,
    bookkeepingHandlers,
    hintStatusHandlers,
    hurdlrHandlers,
    payrollHandlers,
    hubPayrollHandlers,
    sscFunnelHandlers,
    oauthHandlers,
    gustoHandlers,
    legalConsentsHandlers,
    qteHandlers,
] as const;

const seen = new Set<string>();
handlerGroups.forEach((group) => {
    Object.keys(group).forEach((key) => {
        if (seen.has(key)) {
            throw new Error(`Duplicate Storybook MSW handler key: ${key}`);
        }
        seen.add(key);
    });
});

const defaultHandlers = Object.assign({}, ...handlerGroups);

export default defaultHandlers;
